import { Component, ViewChild, inject, signal } from '@angular/core';

import { RouterModule } from '@angular/router';
import { Topbar } from '../topbar/topbar.component';
import { Sidebar } from '../sidebar/sidebar.component';
import { UserStore } from '../../core/store/user/user.store';
import { CoVisrChatComponent } from '../../shared-components/co-visr/co-visr-chat.component';
import { CoVisrStore } from '../../shared-components/co-visr/co-visr.store';

@Component({
  selector: 'layout',
  standalone: true,
  template: `<div class="layout-wrapper layout-sidebar-dark" [class.sidebar-open]="openSidebar()">
    @if (openSidebar()) {
      <sidebar animate.enter="sidebar-enter" animate.leave="sidebar-leave"></sidebar>
    }

    <div class="layout-content-wrapper">
      <div class="layout-content-wrapper-inside">
        <topbar (sidebarToggle)="openSidebar.set(!openSidebar())" (coVisrClick)="coVisrStore.openDrawer()"></topbar>
        <div class="layout-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    @if (!userStore.isSupervisrReadOnly()) {
      <co-visr-chat />
    }
  </div> `,
  imports: [Topbar, Sidebar, RouterModule, CoVisrChatComponent],
  providers: [CoVisrStore],
  styleUrls: ['./layout.component.scss'],
})
export class Layout {
  readonly userStore = inject(UserStore);
  readonly coVisrStore = inject(CoVisrStore);
  readonly openSidebar = signal(true);

  @ViewChild(Sidebar) appSidebar!: Sidebar;

  @ViewChild(Topbar) appTopBar!: Topbar;
}
